import React from "react";
import styled from "styled-components";
import { Timeline_Sales_Session_Changes } from "./Timeline_Sales_Session_Changes";

const TimelineSalesEdit = styled.div`
    display: grid;
    gap: 0.25rem;
    min-width: 0;
    padding: 0.8rem 1rem;
    font-family: "fontMedium", sans-serif;
`;

// Displays the Brand fields edited during the completed Sales session.
export const Timeline_Sales_Session_Edit = (props) => {
    return (
        <TimelineSalesEdit data-testid="timeline-sales-session-edit">
            <Timeline_Sales_Session_Changes event={props.event} t={props.t} />
        </TimelineSalesEdit>
    );
};
